module.exports = __webpack_public_path__ + "img/254e60c.jpg";